const translations = {
    year_index: "წლების მოდული - ნახვა",
    year_store: "წლების მოდული - დამატება",
}

export default translations


